// material-ui
import {styled} from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import {DRAWER_WIDTH, ThemeMode} from "../../../config";
import bgSideBarImage from "../../../../../assets/images/ims-bg-SideBar.jpg";

// project import

const openedMixin = (theme) => ({
    width: DRAWER_WIDTH,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden',
    boxShadow: theme.palette.mode === ThemeMode.DARK ? theme.customShadows.z1 : 'none',
    backgroundImage: `url(${bgSideBarImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: '90px',
    borderRight: 'none',
    boxShadow: theme.customShadows.z1,
    backgroundImage: `url(${bgSideBarImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {shouldForwardProp: (prop) => prop !== 'open'})(({theme, open}) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',


    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme)
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme)
    })
}));

export default MiniDrawerStyled;
